import { c as _c } from "react/compiler-runtime";
import { Pill } from "@/components/atoms/Pill";

/**
 * Renders a single field value as either plain text or a row of pills — the
 * shared building block for "from → to" change summaries (drift dialog,
 * associate-listing step, apply-to-listings).
 */
type Props = {
  text: string;
  pills?: string[];
  emphasized?: boolean;
};
export function FieldDiffValue(t0) {
  const $ = _c(5);
  const {
    text,
    pills,
    emphasized
  } = t0;
  if (pills) {
    let t1;
    if ($[0] !== pills) {
      t1 = pills.length > 0 ? <div className="flex flex-wrap gap-1.5">{pills.map(_temp)}</div> : <span className="text-base text-muted-foreground">—</span>;
      $[0] = pills;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const t1 = emphasized ? "text-base font-semibold text-foreground" : "text-base font-medium text-muted-foreground";
  let t2;
  if ($[2] !== t1 || $[3] !== text) {
    t2 = <span className={t1} data-sentry-component="FieldDiffValue" data-sentry-source-file="FieldDiffValue.tsx">{text}</span>;
    $[2] = t1;
    $[3] = text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(pill) {
  return <Pill key={pill} size="md">{pill}</Pill>;
}